import React from 'react';
import { TrendingUp, TrendingDown, Clock, Calendar, Power, CheckCircle } from 'lucide-react';
import { useReconnectionSummary } from '../../hooks';
import { QuickStatsCard } from '@features/cx/shared/components/QuickStatsCard';
import { useRemoteUtilityId } from '@shared/selectors/globalSelectors';

export const Summary: React.FC = () => {
  const remoteUtilityId = useRemoteUtilityId();
  const { data: summaryData } = useReconnectionSummary({
    remoteUtilityId: Number(remoteUtilityId),
    requestType: 'Reconnection',
  });

  console.log('debug summary reconnection', summaryData)

  const summaryCards = [
    {
      title: 'Pending Reconnections',
      value: summaryData?.pendingCount,
      icon: <Clock className="h-8 w-8 text-orange-500" />,
      color: 'text-orange-600',
      trendSummary: " ",
    },
    {
      title: 'Completed Reconnection',
      value: summaryData?.completedCount,
      icon: <Calendar className="h-8 w-8 text-blue-500" />,
      color: 'text-blue-600',
      trendSummary: " ",

    },
    {
      title: 'Average Processing Time',
      value: summaryData?.averageProcessingDays,
      icon: <CheckCircle className="h-8 w-8 text-green-500" />,
      color: 'text-green-600',
      trendSummary: " ",

    },
    {
      title: 'Rejected',
      value: summaryData?.rejectedCount,
      icon: <Power className="h-8 w-8 text-purple-500" />,
      color: 'text-purple-600',
      trendSummary: " ",

    },
  ];

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 mb-6">
      {summaryCards.map((card, index) => (
        <QuickStatsCard 
          key={index}
          title={card.title}
          count={card.value}
          icon={card.icon}
          trendSummary={card.trendSummary}
        />
      ))}
    </div>
  );
};